import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { ECode, EGroup } from '../../../services/reports';

interface ISurvey {
  share: number;
  name: string;
}

interface IData {
  code: ECode;
  group: EGroup;
  surveys: ISurvey[];
}

interface IXAxisLabel {
  data: IData[];
  angle: number;
  x: number;
  y: number;
  width: number;
  payload: { value: string };
  colors: Record<ECode, string[]>;
}

const XAxisLabel: FC<IXAxisLabel> = ({ width, data, y, colors }) => {
  const centerX = width / 2;
  const squareSize = 20;
  const squareSpacing = 8;
  const rowGap = 5;
  const borderRadius = 4;
  const labelSpacing = 20;

  const theme = useTheme();

  return (
    <g transform={`translate(${centerX},${y - labelSpacing})`}>
      {/* First row of squares */}
      {data.map(({ code }, index) => (
        <rect
          key={`${code}-row1`}
          x={
            index * (squareSize + squareSpacing) - (data.length * (squareSize + squareSpacing)) / 2
          }
          y={-squareSize - rowGap}
          width={squareSize}
          height={squareSize}
          fill={colors[code][0]}
          rx={borderRadius}
          ry={borderRadius}
        />
      ))}

      {/* First row label */}
      <text
        key={`${data[0].code}-text1`}
        x={(data.length * (squareSize + squareSpacing)) / 2}
        y={-squareSize - rowGap + squareSize / 1.5}
        fill={theme.colors.neutral.primary[60]}
        fontSize={12}
        fontWeight={400}
        textAnchor="start"
      >
        {data[0].surveys[0].name}
      </text>

      {/* Second row of squares */}

      {/* Second row label */}
      {data[0].surveys[1] && (
        <>
          {data.map(({ code }, index) => (
            <rect
              key={`${code}-row2`}
              x={
                index * (squareSize + squareSpacing) -
                (data.length * (squareSize + squareSpacing)) / 2
              }
              y={0}
              width={squareSize}
              height={squareSize}
              fill={colors[code][1]}
              rx={borderRadius}
              ry={borderRadius}
            />
          ))}
          <text
            key={`${data[0].code}-text2`}
            x={(data.length * (squareSize + squareSpacing)) / 2}
            y={squareSize + rowGap - squareSize / 2}
            fill={theme.colors.neutral.primary[60]}
            fontSize={12}
            fontWeight={400}
            textAnchor="start"
          >
            {data[0].surveys[1].name}
          </text>
        </>
      )}
    </g>
  );
};

export default XAxisLabel;
